var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"products_new\"\u003E\u003Cproduct-form :errors=\"errors\" @submit=\"createProduct\"\u003E\u003C\u002Fproduct-form\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;